// extracted by mini-css-extract-plugin
module.exports = {"FeaturedStrategicPartnerships":"styles_FeaturedStrategicPartnerships__PUtj3","bg_1":"styles_bg_1__jJO0m","bg_2":"styles_bg_2__k0qxn","height":"styles_height__UGDGe"};